// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3FGfR","banner":"styles_banner__3QEQ3","background":"styles_background__2fe52"};